module.exports = __webpack_public_path__ + "img/arrow.a76e5d04.svg";